module.exports = __webpack_public_path__ + "static/img/265_TO8_2350_og.5652063.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/265_TO8_2350_og.jpg
// module id = y0C4
// module chunks = 0